import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M526-581v202q0 13 12 18 13 5 22-4l87-87q12-12 12-28 0-17-12-28l-87-87q-9-9-22-4-12 5-12 18ZM185-106q-33 0-56-23t-23-56v-590q0-33 23-57t56-23h590q33 0 57 23t23 57v590q0 33-23 56-24 23-57 23H185Zm139-79v-590H185v590h139Zm79 0h372v-590H403v590Zm-79 0H185h139Z"/>',
  f: '<path d="M526-581v202q0 13 12 18 13 5 22-4l87-87q12-12 12-28t-12-28l-87-87q-9-9-22-4-12 5-12 18ZM185-106q-33 0-56-23t-23-56v-590q0-33 23-57t56-23h590q33 0 57 23t23 57v590q0 33-23 56-24 23-57 23H185Zm218-79h372v-590H403v590Z"/>',
};

export default data;
